import { inject, onMounted, ref, type InjectionKey, type Ref } from 'vue'
import { useRoute } from 'vue-router'

import { capitalizeWord } from '@/utils/capitalizeWord'
import { extractDescriptorName } from '@/utils/extractDescriptorName'

export const initialDescriptorKey: InjectionKey<string> = Symbol('initialDescriptor')

export const useCapitalizedDescriptor = (): Ref<string> => {
  const route = useRoute()
  const descriptor = route.meta.descriptor || String(route.params.descriptor || '')
  const initialDescriptor = inject(initialDescriptorKey, '')
  const name = ref(capitalizeWord(descriptor || initialDescriptor))

  onMounted(() => {
    if (!descriptor) {
      name.value = capitalizeWord(extractDescriptorName(window.location.hostname))
    }
  })

  return name
}
